import clamp from 'text-overflow-clamp';


export default class StripTitle extends React.Component {

  static propTypes = {
    text: React.PropTypes.string,
    clampOptions: React.PropTypes.object,
    className: React.PropTypes.string,
  };

  static defaultProps = {
    clampOptions: {},
  };

  componentDidMount() {
    this.clamp();
  }

  componentDidUpdate() {
    this.clamp();
  }

  clamp() {
    clamp(this.title, this.props.clampOptions);
  }

  render() {
    const { className, text } = this.props;

    return (
      <div ref={node => (this.title = node)}
           className={className}
           title={text}>
        {text}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/title/title.js